import React, { useState, useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
  Avatar,
  AppBar,
  Toolbar,
  Badge,
  IconButton,
  Typography,
  MenuItem,
  Fade,
  Menu as MenuComponent,
  Button
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  NotificationsOutlined,
  HelpOutline,
  ExitToApp,
  Menu,
  ExpandMoreOutlined,
  Videocam
} from '@material-ui/icons';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import SchoolOutlinedIcon from '@material-ui/icons/SchoolOutlined';
import PermIdentityIcon from '@material-ui/icons/PermIdentity';
import { HandleLogout } from 'components/';
import { useHistory, Link as RouterLink } from 'react-router-dom';
import { tobBar } from '../../../Minimal/components/Topbar/Topbar';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import { notificationRequest } from 'store/modules/notification/actions';
import useWindowDimensions from 'customHooks/DimensionHook';
import { signInRequest } from 'store/modules/auth/actions';
import Notification from '../../../../components/Notification';
// import DrawerNote from '../../../../../src/components/DrawerNote';
import theme from 'theme';

const useStyles = makeStyles((theme) => ({
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: 240,
      flexShrink: 0,
    },
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    width: '100%',
    height: '64px',
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none !important',
    },
  },
  flexGrow: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
  },
  textIcon: {
    fontFamily: 'Montserrat',
    fontSize: '15px',
    fontWeight: 500,
    letterSpacing: '0.0em',
    [theme.breakpoints.down('md')]: {
      display: 'none !important',
    },
  },
  list: {
    width: '45ch',
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  listItem: {
    display: 'grid',
    gridTemplateColumns: '2fr 1fr',
    padding: theme.spacing(2),
  },
  inline: {
    display: 'inline',
  },
  date: {
    display: 'flex',
    flexDirection: 'column',
    textAlign: 'right',
  },
  notificationTitle: {
    fontSize: 11,
    marginRight: 20,
  },
  notificationDate: {
    fontSize: 11,
    textAlign: 'right',
  },
  notificationAll: {
    textAlign: 'center',
    width: '100%',
    color: 'blue',
    textDecoration: 'underline',
  },
  itemMenuNotification: {
    cursor: 'inherit',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  menuLink: {
    color: 'inherit',
    textDecoration: 'inherit',
  },
  dropDownSpan: {
    fontSize: 14,
    borderBottom: '1px solid #cecece',
    width: '100%',
  },
  linkLogo: {
    display: 'flex'
  },
  responsiveSpan: {
    marginLeft: '2vw',
    fontSize: 'clamp(14px, 2vw, 14px)',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  },
  buttonContainer: {
    textDecoration: 'none',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      display: 'block',
    },
  },
  button: {
    backgroundColor: '#0050EA',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      padding: '8px 12px',
      fontSize: '14px',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '6px 10px',
      fontSize: '12px',
      gap: '4px',
    },
  },
  buttonText: {
    color: '#fff',
    display: 'flex',
    marginLeft: 5,
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      marginLeft: 2,
    },
  },
  textDesktop: {
    color: '#fff',
    display: 'flex',
    marginLeft: 5,
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'none', 
    },
  },
  textMobile: {
    color: '#fff',
    display: 'none',
    marginLeft: 5,
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      display: 'flex', 
    },
  },
  icon: {
    color: '#fff',
    fontSize: '24px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: '16px', 
    },
  },
  live: {
    marginLeft: '6px',
    width: '8px',
    height: '8px',
    backgroundColor: '#ff3b30',
    borderRadius: '50%',
    display: 'inline-block',
    animation: '$pulse 1.5s infinite',
    marginBottom: '2px',
  },
  '@keyframes pulse': {
    '0%': {
      opacity: 1,
      transform: 'scale(1)',
    },
    '50%': {
      opacity: 0.4,
      transform: 'scale(1.2)',
    },
    '100%': {
      opacity: 1,
      transform: 'scale(1)',
    },
  },
}));

export const buttonTheme = createTheme({
  palette: {
    primary: {
      main: '#176AE6',
    },
  },
});

const Topbar = (props) => {
  const [modalStatus, setModalStatus] = useState(false);
  const { open, handleDrawerToggle, onSidebarOpen, ...rest } = props;
  const {
    group,
    name,
    id,
    avatar,
    type,
    email,
    idAdminUser,
    idStudentUser,
  } = useSelector((state) => state.auth);
  const { company } = useSelector((state) => state);
  const classes = useStyles();
  const history = useHistory();
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElDropdown, setAnchorElDropdown] = useState(null);
  const [openNote, setOpenNote] = useState(false);
  const openDropdown = Boolean(anchorElDropdown);

  const { unreaded: notificationsUnreaded } = useSelector(
    (state) => state.notification
  );
  const notificationOpen = Boolean(anchorEl);
  const dispatch = useDispatch();
  const [canSwitchUser, setCanSwitchUser] = useState(false);
  const [customization, setCustomization] = React.useState({
    background_color: '#2A2E43',
    text_color: theme.palette.text.primary,
  });

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickDropdown = (event) => {
    setAnchorElDropdown(event.currentTarget);
  };

  const handleCloseDropdown = () => {
    setAnchorElDropdown(null);
  };

  const openPop = Boolean(anchorEl);

  const handleModalOpen = useCallback(() => {
    setModalStatus(true);
  });

  const handleOpenNotifications = useCallback((event) => {
    setAnchorEl(event.currentTarget);
  });

  const handleCloseNotifications = useCallback(() => {
    setAnchorEl(null);
  });

  const handleAllNotifications = useCallback(() => {
    history.push('/notification');
    setAnchorEl(null);
  });

  const fetchNotifications = async () => {
    dispatch(notificationRequest());
  };

  const handleAdminArea = useCallback(() => {
    try {
      dispatch(
        signInRequest(email, 'any', window.location.hostname, idAdminUser)
      );
    } catch (err) { }
  }, [dispatch]);

  const handleStudentArea = useCallback(() => {
    try {
      dispatch(
        signInRequest(email, 'any', window.location.hostname, idStudentUser)
      );
    } catch (err) { }
  }, [dispatch]);

  useEffect(() => {
    fetchNotifications();
    setCanSwitchUser([idAdminUser, idStudentUser].filter((x) => x).length > 1);
  }, []);

  useEffect(() => {
    if (company?.theme) {
      setCustomization(company?.theme);
    }
  }, [company]);

  const { width } = useWindowDimensions();

  const allowedCompanies = [
    '1a4d6119-683a-459b-84a1-889272adec17',
    'ea1ce206-8fd5-4b55-b2bf-50cd10e8a437',
    'bfb1f883-42c4-488d-9da8-816b3ecdaac8',
    '85dd0a04-05ec-4838-a34e-8585ab8f6d1c'
  ];
  

  return (
    <ThemeProvider theme={tobBar}>
      <AppBar
        position="fixed"
        style={{ backgroundColor: customization?.background_color }}
        className={classes.appBar}
      >
        <Toolbar className='notranslate'>
          {width > 600 && customization?.logo?.url?.length > 0 && (
            <RouterLink to='/' className={classes.linkLogo}>
              <img
                height={50}
                src={customization?.logo?.url}
                style={{ maxWidth: 166, objectFit: 'contain', maxHeight: 40 }}
              ></img>
            </RouterLink>
          )}
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            className={classes.menuButton}
          >
            <Menu style={{ color: customization?.text_color }} />
          </IconButton>
          <div className={classes.flexGrow}>
            {company?.domain_company == '4b44b51e-c4d0-4209-9fcb-1db56f09b036' && (
              <span
                className={classes.responsiveSpan}
                style={{ color: customization?.text_color }}
              >
                Tentativo e Confidencial (Utilização Interna)
              </span>
            )
            }
          </div>
            {/* {type == 2 && (
              <>
              <MenuItem onClick={() => setOpenNote(true)}>
                <IconButton color="inherit">
                    <NotesOutlined style={{ color: customization?.text_color }} />
                  </IconButton>
                    <Typography
                        style={{ color: customization?.text_color }}
                        className={classes.textIcon}
                        variant="caption"
                      >
                        Anotações
                    </Typography>
              </MenuItem>
              
              <DrawerNote
                open={openNote}
                setOpenNote={setOpenNote}
                user={idStudentUser || idAdminUser}
                company={company?.domain_company}
              />
            </>
            )} */}
         {!allowedCompanies.includes(company?.domain_company) && (
            <a
              href="https://www.crescamais.com/ciclo-de-excelencia"
              target="_blank"
              rel="noreferrer"
              className={classes.buttonContainer}
              title="Ciclo de Excelência"
            >
              <Button
                size="medium"
                variant="contained"
                style={{ 
                  backgroundColor: '#0050EA',
                  '&:focus': {
                    backgroundColor: '#0050EA',
                  },
                  '&:active': {
                    backgroundColor: '#0050EA',
                  }
                }}
                disableFocusRipple
                disableRipple
                className={classes.button}
              >
                <Videocam className={classes.icon} />     
                
                <Typography 
                  component="span"
                  variant='span'
                  className={classes.textDesktop}
                >
                  Ciclo de Excelência
                  <span className={classes.live} />
                </Typography>
                
                <Typography 
                  component="span"
                  variant='span'
                  className={classes.textMobile}
                >
                  Excelência
                  <span className={classes.live} />
                </Typography>
              </Button>
            </a>
          )}
          {company?.domain_company !== '4b44b51e-c4d0-4209-9fcb-1db56f09b036' && (
            <a
              style={{ textDecoration: 'none', color: 'inherit' }}
              target="_blank"
              href={window._env_.REACT_APP_TAWK_HELP_URL}
            > 
              <MenuItem>
                <IconButton aria-label="show 4 new mails" color="inherit">
                  <HelpOutline style={{ color: customization?.text_color }} />
                </IconButton>
              </MenuItem>
            </a>
            )
          }
          <MenuItem onClick={handleClick}>
            <IconButton aria-label="show 4 new mails" color="inherit">
              {notificationsUnreaded > 0 && (
                <Badge badgeContent={3} color="secondary" variant="dot">
                  <NotificationsOutlined
                    style={{ color: customization?.text_color }}
                  />
                </Badge>
              )}

              {notificationsUnreaded <= 0 && (
                <NotificationsOutlined
                  style={{ color: customization?.text_color }}
                />
              )}
            </IconButton>
          </MenuItem>

          <MenuComponent
            id="notification-appbar"
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            keepMounted
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            open={notificationOpen}
            onClose={handleCloseNotifications}
          >
            <MenuItem
              className={classes.itemMenuNotification}
              onClick={handleAllNotifications}
            >
              <Notification />
            </MenuItem>
          </MenuComponent>

          {/* TODO Criar DROPDOWN com as opções */}
          <MenuItem onClick={handleClickDropdown}>
            <IconButton
              aria-label="account of current user"
              aria-controls="primary-search-account-menu"
              aria-haspopup="true"
            >
              <Avatar
                alt="Person"
                src={
                  // avatar?.url || `https://www.gravatar.com/avatar/${emailHash}`
                  avatar?.url || '/images/avatars/noUserSbg.png'
                }
              />
            </IconButton>
            <p
              style={{ color: customization?.text_color }}
              className={classes.textIcon}
            >
              {name}
            </p>
            <ExpandMoreOutlined
              style={{ color: customization?.text_color }}
              aria-controls="fade-menu"
              aria-haspopup="true"
            ></ExpandMoreOutlined>
          </MenuItem>
          <div>
            <MenuComponent
              id="fade-menu"
              anchorEl={anchorElDropdown}
              keepMounted
              open={openDropdown}
              onClose={handleCloseDropdown}
              TransitionComponent={Fade}
            >
              <span onClick={handleCloseDropdown}>
                {idAdminUser && (
                  <MenuItem onClick={handleAdminArea}>
                    <span className={classes.dropDownSpan}>
                      <IconButton aria-label="show 4 new mails" color="inherit">
                        <AccountBalanceOutlinedIcon fontSize="small" />
                      </IconButton>
                      Admin
                    </span>
                  </MenuItem>
                )}
                {idStudentUser && (
                  <MenuItem onClick={handleStudentArea}>
                    <span className={classes.dropDownSpan}>
                      <IconButton aria-label="show 4 new mails" color="inherit">
                        <SchoolOutlinedIcon fontSize="small" />
                      </IconButton>
                      Aluno
                    </span>
                  </MenuItem>
                )}
              </span>
              <MenuItem onClick={handleCloseDropdown}>
                <span
                  className={classes.dropDownSpan}
                  onClick={() => history.push(`/users/edit-profile`)}
                >
                  <IconButton aria-label="show 4 new mails" color="inherit">
                    <PermIdentityIcon fontSize="small" />
                  </IconButton>
                  Editar Perfil
                </span>
              </MenuItem>
              <MenuItem>
                <span
                  className={classes.dropDownSpan}
                  onClick={handleModalOpen}
                >
                  <IconButton aria-label="logout">
                    <ExitToApp fontSize="small" className={classes.iconColor} />
                  </IconButton>
                  Sair da Plataforma
                </span>
              </MenuItem>
            </MenuComponent>
          </div>
        </Toolbar>
        <HandleLogout closeModal={setModalStatus} isOpen={modalStatus} />
      </AppBar>
    </ThemeProvider>
  );
};

Topbar.propTypes = {
  className: PropTypes.string,
  onSidebarOpen: PropTypes.func,
};

export default Topbar;
